import { defaultConsole } from '../DefaultConsole'
import { logger } from '../services/Logger'

const log = logger.createChildLogger({ name: 'Console' })

export default class ConsoleLogOverride {
    static disableConsoleLog() {
        // @ts-ignore
        window.console.log = function () {}
        // @ts-ignore
        window.console.info = function () {}
        // @ts-ignore
        window.console.error = function () {}
    }

    static restoreDefaultConsoleLog() {
        // @ts-ignore
        window.console.log = (...args: any) => {
            defaultConsole.log(...args)
            log.console('log', ...args)
        }

        // @ts-ignore
        window.console.info = (...args: any) => {
            defaultConsole.log(...args)
            log.console('info', ...args)
        }

        // @ts-ignore
        window.console.error = (...args: any) => {
            defaultConsole.error(...args)
            log.console('error', ...args)
        }
    }
}
